import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Star, X } from "lucide-react";
import { toast } from "sonner";
import { AppButton, Field } from "@/components/AppUI";
import { formatError, papi } from "@/lib/pizzeria";

export default function FeedbackPage() {
  const { orderId } = useParams();
  const nav = useNavigate();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!rating) return setError("Seleziona un voto da 1 a 5 stelle");
    setLoading(true);
    try {
      await papi.post("/feedback", { order_id: orderId, rating, comment: comment.trim() });
      toast.success("Grazie per la tua recensione!");
      nav("/ordini", { replace: true });
    } catch (e) {
      setError(formatError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex-1" data-testid="feedback-page">
      <div className="flex items-center justify-between p-4">
        <h1 className="text-2xl font-medium">Com'è andata?</h1>
        <button onClick={() => nav(-1)} className="h-10 w-10 rounded-full grid place-items-center" style={{ background: "var(--surface-3)" }} data-testid="feedback-close-button"><X className="h-5 w-5" /></button>
      </div>
      <div className="px-4 space-y-6">
        <p className="text-base" style={{ color: "var(--muted-c)" }}>Il tuo parere ci aiuta a migliorare ogni giorno.</p>
        <div className="flex justify-center gap-2">
          {[1, 2, 3, 4, 5].map((n) => <button key={n} onClick={() => { setRating(n); setError(""); }} className="p-1" data-testid={`feedback-star-${n}`}><Star className="h-10 w-10" style={{ color: "#F59E0B", fill: n <= rating ? "#F59E0B" : "none" }} /></button>)}
        </div>
        <Field label="Commento" testId="feedback-comment-input" value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Raccontaci la tua esperienza..." multiline />
        {error && <p className="text-sm" style={{ color: "var(--brand)" }} data-testid="feedback-error">{error}</p>}
        <AppButton title="Invia recensione" loading={loading} onClick={submit} testId="feedback-submit-button" className="w-full" />
      </div>
    </div>
  );
}
